'use client';
import React from 'react';
import { JucyIcon, JucyIconProps } from './JucyIcon';

export interface FleetTypeIconProps extends Omit<JucyIconProps, 'icon'> {
    fleetType: 'car' | 'campervan' | 'motorhome';
}

export const FleetTypeIcon: React.FC<FleetTypeIconProps> = ({ fleetType, className, ...props }) => <JucyIcon icon={fleetType} {...props} />;
